import React from 'react';

import { useMinimalCartUi } from 'features/cart/hooks/use-minimal-cart-ui';

import { useUpsellPersonalizationExperiment } from 'experiments/use-upsell-personalization-experiment';
import { useAuthContext } from 'state/auth';

import { PersonalizedUpsell } from './experiment/upsell';
import { usePersonalizedMenuFeatureUpsell } from './experiment/use-menu-feature-upsell';
import { IUpsellStrategyProps } from './types';
import { Upsell } from './upsell';
import { useMenuFeatureUpsell } from './use-menu-feature-upsell';

const DefaultMenuFeatureUpsell: React.FC<IUpsellStrategyProps> = ({ isInCart }) => {
  const upsellData = useMenuFeatureUpsell();

  return <Upsell {...upsellData} isInCart={isInCart} />;
};

interface PersonalizedMenuFeatureUpsellProps extends IUpsellStrategyProps {
  sanityIds: string[];
}

const PersonalizedMenuFeatureUpsell: React.FC<PersonalizedMenuFeatureUpsellProps> = ({
  isInCart,
  sanityIds,
}) => {
  const upsellData = usePersonalizedMenuFeatureUpsell({
    personalizedSanityIds: sanityIds,
  });

  return <PersonalizedUpsell {...upsellData} isInCart={isInCart} />;
};

const MenuFeatureUpsell: React.FC<IUpsellStrategyProps> = props => {
  const isMinimalCartUiEnabled = useMinimalCartUi();

  const { isLoading: isExperimentLoading, sanityIds, variant } = useUpsellPersonalizationExperiment(
    isMinimalCartUiEnabled
  );

  const isExperimentResolved = !isExperimentLoading && !!variant;
  const isTreatmentVariant = isExperimentResolved && variant !== 'control';

  const shouldUsePersonalizedUpsell = !isMinimalCartUiEnabled && isTreatmentVariant;

  return shouldUsePersonalizedUpsell ? (
    <PersonalizedMenuFeatureUpsell {...props} sanityIds={sanityIds ?? []} />
  ) : (
    <DefaultMenuFeatureUpsell {...props} />
  );
};

export const UpsellStrategy: React.FC<IUpsellStrategyProps> = props => {
  const { isAuthenticated } = useAuthContext();
  return isAuthenticated ? <MenuFeatureUpsell {...props} /> : null;
};
